import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=134130eb&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=134130eb&prod&scoped=true&lang=css"
import style1 from "./HomeNew.vue?vue&type=style&index=1&id=134130eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134130eb",
  null
  
)

export default component.exports